import { useTheme } from 'styled-components';
import type { FreeLinkConfig } from '@elfsight/widget-free-link';
import { FreeLink, pickFreeLinkSettings } from '@elfsight/widget-free-link';
import { useIsMobile } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { meta } from '../../meta';
import { usePageContext } from '../hooks/use-page';

export function StyledFreeLink() {
  const settings = useSettings();
  const theme = useTheme();
  const {
    scrollState: { hasScroll, isAtBottom }
  } = usePageContext();
  const isMobile = useIsMobile();

  const freeLinkSettings = pickFreeLinkSettings(settings);

  const shouldShowTopBorder = hasScroll && !isAtBottom;

  const style: FreeLinkConfig['style'] = {
    link: {
      position: 'absolute',
      bottom: '0',
      width: '100%',
      height: 'fit-content',
      padding: isMobile ? '12px 8px' : '12px 28px',
      margin: 0,
      fontWeight: 400,
      lineHeight: '9px',
      borderRadius: 0,
      borderTop: shouldShowTopBorder
        ? `1px solid ${theme.freeLink.borderColor}`
        : 'none'
    },
    removeText: {
      fontWeight: 600,
      marginLeft: 'auto'
    }
  };

  return (
    <FreeLink
      {...freeLinkSettings}
      appAlias={meta.appAlias}
      appName={meta.appName}
      mode="text"
      textModeProps={{
        fontSize: 11,
        customColor: theme.freeLink.textColor
      }}
      style={style}
    />
  );
}
